import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type DistributionList from "./DistributionList";
import type MediaRequest from "./MediaRequest";
import type Organisation from "./Organisation";
import type OrganisationContract from "./OrganisationContract";
import type OrganisationFeatureAllowance from "./OrganisationFeatureAllowance";
import type OrganisationReportSpec from "./OrganisationReportSpec";
import type OrganisationsFeature from "./OrganisationsFeature";
import type QuerySnippet from "./QuerySnippet";
import type Stream from "./Stream";
import type TranscriptRequest from "./TranscriptRequest";
import type User from "./User";

@Model()
class Version extends ApplicationRecord {
  static jsonapiType = "versions";

  @Attr({ persist: false }) createdAt: string;

  @Attr() event: string;

  @Attr() feature: string;

  @BelongsTo() item:
    | DistributionList
    | Organisation
    | OrganisationReportSpec
    | OrganisationContract
    | OrganisationsFeature
    | OrganisationFeatureAllowance
    | Stream
    | TranscriptRequest
    | User
    | MediaRequest
    | QuerySnippet;

  @Attr() itemId: number;

  @Attr() itemType: string;

  @Attr() object: Record<string, any>;

  @Attr() objectChanges: Record<string, any>;

  @BelongsTo() user: User;
}

export default Version;
